module.exports = __webpack_public_path__ + "media/I_illustration.57c68886.mp3";